import { useState } from 'react';
import { Form, Card, Row, Col, Button, Image } from 'react-bootstrap';
import icGlobalSize from './assets/img/ic-user-group.svg';
import icLocalSize from './assets/img/ic-user-multiple.svg';
import icRating from './assets/img/ic-star-square.svg';
import icStar from './assets/img/ic-star.svg';
import icStarGray from './assets/img/ic-star-gray.svg';
import icRatingSource from './assets/img/ic-stack-star.svg';

const CompanyAddSize = ({ formData, handleChange, handleSizeSubmit, isEditPage}) => {
    const [isEditing, setIsEditing] = useState(!isEditPage); // ✅ If adding, fields are enabled
    const [tempFormData, setTempFormData] = useState({ ...formData }); // ✅ Store initial values

    // ✅ Enable editing mode
    const handleEditClick = () => {
        setIsEditing(true);
        setTempFormData({ ...formData }); // ✅ Store previous values
    };

    // ✅ Save changes and disable editing
    const handleSaveClick = async (e) => {
        e.preventDefault();
        if (typeof handleSizeSubmit === 'function') { // ✅ Ensure it's a function before calling
            await handleSizeSubmit(e);
            setIsEditing(false); // ✅ Exit edit mode after saving
        } else {
            console.error('Error: handleSizeSubmit is not a function.');
        }
    };

    // ✅ Cancel editing and restore previous values
    const handleCancelClick = () => {
        setIsEditing(false);
        Object.keys(tempFormData).forEach((key) => {
            handleChange({ target: { name: key, value: tempFormData[key] } });
        });
    };

    return (
        <>
            <Card>
                <Card.Body>
                    <Row>
                        <Col md={12}>
                            {isEditPage && (
                                <div className="float-end">
                                    {!isEditing ? (
                                        <Button variant="outline-secondary" className="btn-sm" onClick={handleEditClick}>Edit</Button>
                                    ) : (
                                        <>
                                            <Button variant="outline-secondary" className="btn-sm me-2" onClick={handleCancelClick}>Cancel</Button>
                                            <Button variant="primary" className="btn-sm" onClick={handleSaveClick}>Save</Button>
                                        </>
                                    )}
                                </div>
                            )}
                            <h3><span className="item-number">3.</span> Size</h3>
                            <hr />
                        </Col>
                    </Row>
                    {isEditing ? (
                        <>
                            <Row className="mb-4">
                                <Col md={6}> 
                                    {/* Global Company Size */}
                                    <Form.Group controlId="globalSize">
                                        <Form.Label>Global Company Size</Form.Label>
                                        <Form.Select
                                            name="globalSize"
                                            value={formData.globalSize}
                                            onChange={handleChange}
                                            required
                                            disabled={!isEditing} // ✅ Disable input when not in edit mode
                                        >
                                            <option value="">Please Select</option>
                                            <option value="1-10">1  - 10 employees</option>
                                            <option value="11-50">11 - 50 employees</option>
                                            <option value="51-200">51 - 200 employees</option>
                                            <option value="201-500">201 - 500 employees</option>
                                            <option value="501-1000">501 - 1,000 employees</option>
                                            <option value="1001-5000">1,001 - 5,000 employees</option>
                                            <option value="5001-10000">5,001 - 10,000 employees</option>
                                            <option value="10001-50000">10001 - 50000 employees</option>
                                            <option value="50001-100000">50001 - 100000</option>
                                            <option value="over 100000">over 100000</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    {/* Local Company Size */}
                                    <Form.Group controlId="localSize">
                                        <Form.Label>Local Company Size</Form.Label>
                                        <Form.Select
                                            name="localSize"
                                            value={formData.localSize}
                                            onChange={handleChange}
                                            required
                                            disabled={!isEditing} // ✅ Disable input when not in edit mode
                                        >
                                            <option value="">Please Select</option>
                                            <option value="1-10">1  - 10 employees</option>
                                            <option value="11-50">11 - 50 employees</option>
                                            <option value="51-200">51 - 200 employees</option>
                                            <option value="201-500">201 - 500 employees</option>
                                            <option value="501-1000">501 - 1,000 employees</option>
                                            <option value="1001-5000">1,001 - 5,000 employees</option>
                                            <option value="5001-10000">5,001 - 10,000 employees</option>
                                            <option value="10001-50000">10001 - 50000 employees</option>
                                            <option value="50001-100000">50001 - 100000</option>
                                            <option value="over 100000">over 100000</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <Col md={6}>
                                    {/* Company Rating */}
                                    <Form.Group controlId="rating">
                                        <Form.Label>Company Rating</Form.Label>
                                        <Form.Select
                                            name="rating"
                                            value={formData.rating}
                                            onChange={handleChange}
                                            disabled={!isEditing} // ✅ Disable input when not in edit mode
                                        >
                                            <option value="">Please Select</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    {/* Company Rating Source */}
                                    <Form.Group controlId="ratingSource">
                                        <Form.Label>Company Rating Source</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="ratingSource"
                                            value={formData.ratingSource}
                                            onChange={handleChange}
                                            disabled={!isEditing} // ✅ Disable input when not in edit mode    
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </>
                    ) : (
                        <>
                            {/* Not Editing */}
                            <Row className="mb-4">
                                <Col md={6}> 
                                    {/* Global Company Size */}
                                    <div className="icon-text">
                                        <span className="icon" aria-hidden="true">
                                            <Image
                                                src={icGlobalSize}
                                                alt="Global company size"
                                            />
                                        </span>
                                        <span className="text">
                                            Global company size:
                                            <br />
                                            <strong>{formData.globalSize || "N/A"}</strong>
                                        </span>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    {/* Local Company Size */}
                                    <div className="icon-text">
                                        <span className="icon" aria-hidden="true">
                                            <Image
                                                src={icLocalSize}
                                                alt="Local Company Size"
                                            />
                                        </span>
                                        <span className="text">
                                            Local Company Size:
                                            <br />
                                            <strong>{formData.localSize || "N/A"}</strong>
                                        </span>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    {/* Company Rating */}
                                    <div className="icon-text">
                                        <span className="icon" aria-hidden="true">
                                            <Image
                                                src={icRating}
                                                alt="Company Rating"
                                            />
                                        </span>
                                        <span className="text rating">
                                            Company Rating:
                                            <br />
                                            {Array.from({ length: 5 }).map((_, index) => (
                                                <Image
                                                    key={index} // ✅ Correctly placed on the direct child of .map()
                                                    className="rating-star"
                                                    src={index < formData.rating ? icStar : icStarGray}
                                                    alt=""
                                                />
                                            ))}

                                            <span className="rating-text">
                                                ({formData.rating} star)
                                            </span>
                                        </span>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    {/* Company Rating Source */}
                                    <div className="icon-text">
                                        <span className="icon" aria-hidden="true">
                                            <Image
                                                src={icRatingSource}
                                                alt="Company Rating Source"
                                            />
                                        </span>
                                        <span className="text">
                                            Company Rating Source:
                                            <br />
                                            <strong>
                                                {formData.ratingSource || "N/A"}
                                            </strong>
                                        </span>
                                    </div>
                                </Col>
                            </Row>
                        </>
                    )}
                </Card.Body>
            </Card>

        </>
    );
};

export default CompanyAddSize;
